import AoneService from "../axiosbase";
//upload status mappings
export const uploadStatusMappings = async (formData) => {
  try {
    return await AoneService.post(
      `customers/api/v1/customers/integration/status-mappings/upload`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  } catch (error) {
    return error;
  }
};

//upload failed reason mappings
export const uploadReasonMappings = async (formData) => {
  try {
    return await AoneService.post(
      `customers/api/v1/customers/integration/reason-mappings/upload`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  } catch (error) {
    return error;
  }
};

//create or update customer integration
export const createOrUpdateCustomerIntegration = async (data) => {
  try {
    return await AoneService.post(
      `customers/api/v1/customers/integration/`,
      data
    );
  } catch (error) {
    return error;
  }
};
//disable status push
export const disableStatusPush = async (params) => {
  try {
    return await AoneService.patch(
      `customers/api/v1/customers/integration/${params}/disable`);
  } catch (error) {
    return error;
  }
};
//update status mapping active flag
export const updateStatusMappingActiveFlag = async (id, data) => {
  try {
    return await AoneService.patch(
      `customers/api/v1/customers/integration/status-mappings/${id}/active`,
      data
    );
  } catch (error) {
    return error;
  }
};

//update failed reason mapping active flag
export const updateReasonMappingActiveFlag = async (id, data) => {
  try {
    return await AoneService.patch(
      `customers/api/v1/customers/integration/reason-mappings/${id}/active`,
      data
    );
  } catch (error) {
    return error;
  }
};

//get customer integration data
export const getCustomerIntegration = async (account) => {
  try {
    return await AoneService.get(
      `customers/api/v1/customers/integration/${account}`
    );
  } catch (error) {
    return error;
  }
};

//download status mapping upload template
export const downloadStatusMappingTemplate = async () => {
  try {
    return await AoneService.get(
      `customers/api/v1/customers/integration/status-mappings/upload-template`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//download failed reason mapping upload template
export const downloadReasonMappingTemplate = async () => {
  try {
    return await AoneService.get(
      `customers/api/v1/customers/integration/reason-mappings/upload-template`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//delete status mapping record
export const deleteStatusMapping = async (id) => {
  try {
    return await AoneService.delete(
      `customers/api/v1/customers/integration/${id}/status-mappings`
    );
  } catch (error) {
    return error;
  }
};

//delete failed reason mapping record
export const deleteReasonMapping = async (id) => {
  try {
    return await AoneService.delete(
      `customers/api/v1/customers/integration/${id}/reason-mappings`
    );
  } catch (error) {
    return error;
  }
};
//Lookups
   export const getPushStrategy = async () => {
    try {
      return await AoneService.get(`customers/api/v1/lookups/PushStrategy`);
    } catch (error) {
      return error;
    }
  };
     export const getAuthType = async () => {
    try {
      return await AoneService.get(`customers/api/v1/lookups/AuthType`);
    } catch (error) {
      return error;
    }
  };
     export const getRetryStrategy = async () => {
    try {
      return await AoneService.get(`customers/api/v1/lookups/RetryStrategy`);
    } catch (error) {
      return error;
    }
  };
     export const getReasonType = async () => {
    try {
      return await AoneService.get(`customers/api/v1/lookups/ReasonType`);
    } catch (error) {
      return error;
    }
  };
       export const getStatusCodes = async () => {
    try {
      return await AoneService.get(`customers/api/v1/lookups/external-event`);
    } catch (error) {
      return error;
    }
  };

  export const getCustomerHttpStatusList = async () => {
    try {
      return await AoneService.get(`customers/api/v1/lookups/CustomerHttpStatus`);
    } catch (error) {
      return error;
    }
  };

  export const getChargeableWeightStrategyList = async () => {
    try {
      return await AoneService.get(`orders/api/v1/lookups/ChargeableWeightStrategy`);
    } catch (error) {
      return error;
    }
  };

// RTO concat config
export const getRtoConcatConfig = async (account) => {
  try {
    return await AoneService.get(`customers/api/v1/customers/rto-concat-configs/${account}`);
  } catch (error) {
    return error;
  }
};

export const saveRtoConcatConfig = async (account, data) => {
  try {
    return await AoneService.post(`customers/api/v1/customers/rto-concat-configs/${account}`, data);
  } catch (error) {
    return error;
  }
};

//crm customers
//get
export const getCustomer = async (params) => {
  try {
    return await AoneService.get(`customers/api/v1/customers/${params}`);
  } catch (error) {
    return error;
  }
};

//filter customer
export const filterCustomer = async (params) => {
  try {
    return await AoneService.get(`customers/api/v1/customers/filter${params}`);
  } catch (error) {
    return error;
  }
};

//export
export const exportCustomer = async (params) => {
  try {
    return await AoneService.get(
      "customers/api/v1/customers/export?" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const customerTemplate = async () => {
  try {
    return await AoneService.get(
      `customers/api/v1/customers/template/download`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const customerImport = async (data) => {
  try {
    return await AoneService.post(`customers/api/v1/customers/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

//sync
export const syncCustomer = async (data) => {
  try {
    return await AoneService.post("customers/api/v1/customers/sync", data);
  } catch (error) {
    return error;
  }
};

//delete
export const deleteCustomer = async (params) => {
  try {
    return await AoneService.delete(`customers/api/v1/customers/${params}`);
  } catch (error) {
    return error;
  }
};

//add customers
export const addCustomer = async (data) => {
  try {
    return await AoneService.post("customers/api/v1/customers/", data);
  } catch (error) {
    return error;
  }
};

//get by id
export const getCustomerbyId = async (params) => {
  try {
    return await AoneService.get(
      `customers/api/v1/customers/${params}/account`
    );
  } catch (error) {
    return error;
  }
};

//customer type
export const getCusType = async () => {
  try {
    return await AoneService.get(
      `customers/api/v1/lookups/ZatcaCustomersType`
    );
  } catch (error) {
    return error;
  }
};

//seller type
export const getSellerType = async () => {
  try {
    return await AoneService.get(
      `customers/api/v1/lookups/SellerType`
    );
  } catch (error) {
    return error;
  }
};

//push customers
export const pushOracleCustomer = async (params) => {
  try {
    return await AoneService.post(`customers/api/v1/customers/${params}/kafka`);
  } catch (error) {
    return error;
  }
};

//edit account
export const editCustomerbyId = async (params, data) => {
  try {
    return await AoneService.patch(
      `customers/api/v1/customers/${params}/account`,
      data
    );
  } catch (error) {
    return error;
  }
};

//update sales person for customer
export const editSalesPerson = async (params, params2,data) => {
  try {
    return await AoneService.patch(`customers/api/v1/customers/${params}/account/salesperson?salesperson=${params2}`,data);
  } catch (error) {
    return error;
  }
};

//get billing address
export const getBillingbyId = async (params) => {
  try {
    return await AoneService.get(
      `customers/api/v1/customers/${params}/billing-address`
    );
  } catch (error) {
    return error;
  }
};

//post billing address
export const postBillingAddress = async (params, data) => {
  try {
    return await AoneService.post(
      `customers/api/v1/customers/${params}/billing-address`,
      data
    );
  } catch (error) {
    return error;
  }
};

//edit billing address
export const editBillingAddress = async (params, data) => {
  try {
    return await AoneService.put(
      `customers/api/v1/customers/${params}/billing-address`,
      data
    );
  } catch (error) {
    return error;
  }
};

//get bank details
export const getBankdetailbyId = async (params) => {
  try {
    return await AoneService.get(
      `customers/api/v1/customers/${params}/bank-details`
    );
  } catch (error) {
    return error;
  }
};

//post bank details
export const postBankAddress = async (params, data) => {
  try {
    return await AoneService.post(
      `customers/api/v1/customers/${params}/bank-details`,
      data
    );
  } catch (error) {
    return error;
  }
};

//edit billing address
export const editBankAddress = async (params, data) => {
  try {
    return await AoneService.put(
      `customers/api/v1/customers/${params}/bank-details`,
      data
    );
  } catch (error) {
    return error;
  }
};

//get booking system
export const getBookingbyId = async (params) => {
  try {
    return await AoneService.get(
      `customers/api/v1/customer/${params}/booking-settings`
    );
  } catch (error) {
    return error;
  }
};

//edit booking system
export const editBookingSystem = async (data) => {
  try {
    return await AoneService.put(
      `customers/api/v1/customer/booking-settings`,data);
  } catch (error) {
    return error;
  }
};

//get invoice config
export const getInvoiceConfigbyId = async (params) => {
  try {
    return await AoneService.get(
      `customers/api/v1/customers/${params}/invoice-configurations`
    );
  } catch (error) {
    return error;
  }
};

//edit invoice config
export const postInvoiceSystem = async (params,data) => {
  try {
    return await AoneService.post(
      `customers/api/v1/customers/${params}/invoice-configurations`,data);
  } catch (error) {
    return error;
  }
};

export const editInvoiceSystem = async (params,data) => {
  try {
    return await AoneService.put(
      `customers/api/v1/customers/${params}/invoice-configurations`,data);
  } catch (error) {
    return error;
  }
};

//get pickup address
export const getpickupaddressbyId = async (params, params2) => {
  try {
    return await AoneService.get(
      `customers/api/v1/customers/${params}/pickup-address${params2}`
    );
  } catch (error) {
    return error;
  }
};

export const filterpickupaddressbyId = async (params, params2) => {
  try {
    return await AoneService.get(
      `customers/api/v1/customers/${params}/filter/pickup-address${params2}`
    );
  } catch (error) {
    return error;
  }
};

//post pickup address
export const postpikcupAddress = async (params, data) => {
  try {
    return await AoneService.post(
      `customers/api/v1/customers/${params}/pickup-address`,
      data
    );
  } catch (error) {
    return error;
  }
};

//delete pickup address
export const deletepickupaddressbyId = async (params,params2) => {
  try {
    return await AoneService.delete(
      `customers/api/v1/customers/${params}/pickup-address/${params2}`
    );
  } catch (error) {
    return error;
  }
};

//edit pickup address
export const editpickupaddress = async (params, params2, data) => {
  try {
    return await AoneService.put(
      `customers/api/v1/customers/${params}/pickup-address/${params2}`,
      data
    );
  } catch (error) {
    return error;
  }
};

//delete pickup address
export const deletepickupaddress = async (params) => {
  try {
    return await AoneService.delete(
      `customers/api/v1/customers/pickup-address/${params}`
    );
  } catch (error) {
    return error;
  }
};

//get pickup address
export const getRtoaddressbyId = async (params) => {
  try {
    return await AoneService.get(
      `customers/api/v1/customers/${params}/rto-address`
    );
  } catch (error) {
    return error;
  }
};

//post pickup address
export const postRtoAddress = async (params, data) => {
  try {
    return await AoneService.post(
      `customers/api/v1/customers/${params}/rto-address`,
      data
    );
  } catch (error) {
    return error;
  }
};

//edit pickup address
export const editRtoaddress = async (params, data) => {
  try {
    return await AoneService.put(
      `customers/api/v1/customers/${params}/rto-address`,
      data
    );
  } catch (error) {
    return error;
  }
};

//user information for customers
//create login information for customers
export const customerLoginInfo = async (params, data) => {
  try {
    return await AoneService.post(
      `customers/api/v1/customers/${params}/user-management`,
      data
    );
  } catch (error) {
    return error;
  }
};

//reset password for customers
export const resetCustomerPassword = async (data) => {
  try {
    return await AoneService.post(
      `customers/api/v1/customers/user-management/reset-password`,
      data
    );
  } catch (error) {
    return error;
  }
};

//add attributes for customers
export const AddCustomerAttribute = async (data) => {
  try {
    return await AoneService.post(
      `customers/api/v1/customers/attributes`,
      data
    );
  } catch (error) {
    return error;
  }
};

//toggle password
export const toggleCustomerPassword = async (params,params2) => {
  try {
    return await AoneService.get(
      `customers/api/v1/customers/user-management/toggle-user-status/${params}/${params2}`);
  } catch (error) {
    return error;
  }
};

//generate password
export const generateCustomerPassword = async () => {
  try {
    return await AoneService.get(
      `customers/api/v1/customers/user-management/generate-password`);
  } catch (error) {
    return error;
  }
};

export const getCustomerType = async () => {
  try {
    return await AoneService.get("customers/api/v1/lookups/CustomersType");
  } catch (error) {
    return error;
  }
};

export const getBillingPeriod = async () => {
  try {
    return await AoneService.get("customers/api/v1/lookups/BillingPeriod");
  } catch (error) {
    return error;
  }
};

export const createCodSetting = async (accountNumber, data) => {
  try {
    return await AoneService.post(`customers/api/v1/customers/${accountNumber}/cod/settings`, data);
  } catch (error) {
    return error;
  }
};

export const updateCodSetting = async (accountNumber, data) => {
  try {
    return await AoneService.put(`customers/api/v1/customers/${accountNumber}/cod/settings`, data);
  } catch (error) {
    return error;
  }
};

export const getCodSetting = async (accountNumber) => {
  try {
    return await AoneService.get(`customers/api/v1/customers/${accountNumber}/cod/settings`);
  } catch (error) {
    return error;
  }
};

export const getCustomLabelSettings = async (customerAccount) => {
  try {
    return await AoneService.get(
      `customers/api/v1/customer/${customerAccount}/label-settings`
    );
  } catch (error) {
    return error;
  }
};

export const updateCustomLabelSettings= async (data) => {
  try {
    return await AoneService.put(
      `customers/api/v1/customer/label-settings`, data);
  } catch (error) {
    return error;
  }
};

export const getManifestationSettings = async (customerAccount) => {
  try {
    return await AoneService.get(
      `customers/api/v1/customer/${customerAccount}/manifestation-settings`
    );
  } catch (error) {
    return error;
  }
};

export const updateManifestationSettings = async (data) => {
  try {
    return await AoneService.put(
      `customers/api/v1/customer/manifestation-settings`, data);
  } catch (error) {
    return error;
  }
};
